var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { AbfragerLayout } from '../../layout/AbfragerLayout';
let AbfragerEmptyScene = class AbfragerEmptyScene extends React.PureComponent {
    render() {
        const { app } = this.props;
        return (React.createElement(AbfragerLayout, { app: app, questionContainer: React.createElement("div", { style: { marginTop: 30, marginLeft: 30, fontSize: 26 } }, "W\u00E4hle ein Thema aus!"), answerContainer: null, answerBottom: null, menuContainer: null }));
    }
};
AbfragerEmptyScene = __decorate([
    observer
], AbfragerEmptyScene);
export { AbfragerEmptyScene };
